import { render, staticRenderFns } from "./ComplaintTypeCards.vue?vue&type=template&id=fd5d20fa&"
import script from "./ComplaintTypeCards.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports